module.exports = __webpack_public_path__ + "1eac1f3a71340a586d75ab7d91da9d0a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-5.png
// module id = 1445
// module chunks = 0